module.exports = __webpack_public_path__ + "static/media/rhs.bcebffba.png";